import React from 'react';
import Backdrop from '../../containers/UI/Backdrop/Backdrop';
import styles from './SideDrawer.css';
import {  FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faShoppingCart } from '@fortawesome/free-solid-svg-icons';


const SideDrawer = props => {
    let attachedstyles = [styles.SideDrawer, styles.Close];
    if (props.open) {
        attachedstyles = [styles.SideDrawer, styles.Open];
    }
    return (
        <React.Fragment>
            <Backdrop show={props.open} clicked={props.closed} />
            <div className={attachedstyles.join(' ')}
                onClick={props.closed}>
                <button clicked={styles.Close}>Close</button>
                <nav>
                        <li><a href="#nigiri">Nigiri</a></li>
                        <li><a href="#maki">Maki</a></li>
                        <li><a href="#soups">Soups</a></li>
                        <li><a href="#sweets">Sweets</a></li>
                        <li><a href="#bevereges">Bevereges</a></li>
                        <li><a href="#order">Order <FontAwesomeIcon icon={faShoppingCart} size='xs'/></a></li>
                </nav>
            </div>
        </React.Fragment>
    );

}

export default SideDrawer;


// WEBPACK FOOTER //
// ./src/containers/SideDrawer/SideDrawer.js